import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {map} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  // carSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  // carImportType: BehaviorSubject<any> = new BehaviorSubject(null);
  // carResponseSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient) {
  }

  getPaymentIframe(params: any) {
    return this.http.post(URLS.API + 'subscribe/green', params, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

  getUserSubscription(params: any) {
    return this.http.post(URLS.API + 'subscribe/green/subscription', params, {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }

}
